interface TEntry {
  groupName?: string;
  items?: TEntry[];
  item?: TEntry;
  disabled?: boolean;
  [key: string]: any;
}

export function isGroup(entry?: TEntry) {
  return !!entry && !!entry.groupName && !!entry.items;
}

export function indexOfItem(
  originalCollection: TEntry[] | undefined,
  item: unknown
) {
  let index = 0;
  return (function walk(collection?: TEntry[]): number | undefined {
    if (!collection) {
      return undefined;
    }
    for (let i = 0; i < collection.length; i++) {
      const entry = collection.at(i);
      if (entry && isGroup(entry as TEntry)) {
        const result = walk(entry?.items);
        if (result && result > -1) {
          return result;
        }
      } else if (entry === item) {
        return index;
      } else {
        index++;
      }
    }
    return -1;
  })(originalCollection);
}
